export const matchesLocationFilter = (
  locationData: { city: string; province: string; country: string }[],
  selectedFilters: { city?: string; province?: string; country?: string }
): boolean => {
  if (selectedFilters.city && !locationData.some(({ city }) => city === selectedFilters.city)) return false
  if (selectedFilters.province && !locationData.some(({ province }) => province === selectedFilters.province)) return false
  if (selectedFilters.country && !locationData.some(({ country }) => country === selectedFilters.country)) return false
  return true
}
